module.exports = {
    environment: {
        API_AUTHZ_URL: "https://api.paylead.fr/api-authz",
        API_PERKS_URL: "https://api.paylead.fr/api-perks",
        API_URL: 'https://api.paylead.fr',
        APP_URL: 'https://shift.paylead.fr',
        CAPTCHA_KEY: '6LfDBiIiAAAAALEWbj1-bv1ePSlW6KwYvgzYHUCB',
        ENVIRONMENT: 'prod',
        FF_MY_BENCHMARK: true,
        FF_API_KEYS_V2: true,
        HMR: false,
        PIANO_DOMAIN: 'lbgrcmm.pa-cd.com',
        PIANO_KEY: '646291',
        PROD: true,
        SENTRY_DSN: 'https://f73416cd0b534a16bd5537c6d442d52f@sentry.infra.paylead.fr/6',
        SENTRY_REPLAY_SAMPLE_RATE_ON_ERROR: 1,
        SENTRY_REPLAY_SAMPLE_RATE: 0.1,
        SENTRY_TRACE_RATE: 0.1,
        SSO_API_PERKS_URL: "/api-perks",
        SSO_API_URL: '/api',
    }
}
